import moment from 'moment/moment';
import {
    LAST_SEVEN_DAYS,
    LAST_SIX_MONTHS,
    LAST_THREE_MONTHS,
    LAST_YEAR,
    SINCE_START,
    THIS_MONTH,
    THIS_YEAR,
    TODAY,
    YESTERDAY,
} from './organization-statistics-model';
import { formatToNbDate } from '../../../utils';

const TODAY_FORMATTED = formatToNbDate(new Date());

export default class OrganizationStatisticsDateUtils {
    constructor(organizationCreatedAt) {
        this.organizationCreatedAt = organizationCreatedAt;
    }

    #predefinedDates() {
        return {
            [SINCE_START]: {
                fromDate: formatToNbDate(this.organizationCreatedAt),
                toDate: TODAY_FORMATTED,
            },
            [TODAY]: {
                fromDate: TODAY_FORMATTED,
                toDate: TODAY_FORMATTED,
            },
            [YESTERDAY]: {
                fromDate: formatToNbDate(moment().subtract(1, 'day')),
                toDate: formatToNbDate(moment().subtract(1, 'day')),
            },
            [LAST_SEVEN_DAYS]: {
                fromDate: formatToNbDate(moment().subtract(7, 'day')),
                toDate: TODAY_FORMATTED,
            },
            [THIS_MONTH]: {
                fromDate: formatToNbDate(moment().date(1)),
                toDate: TODAY_FORMATTED,
            },
            [LAST_THREE_MONTHS]: {
                fromDate: formatToNbDate(moment().subtract(3, 'months')),
                toDate: TODAY_FORMATTED,
            },
            [LAST_SIX_MONTHS]: {
                fromDate: formatToNbDate(moment().subtract(6, 'months')),
                toDate: TODAY_FORMATTED,
            },
            [THIS_YEAR]: {
                fromDate: formatToNbDate(moment().dayOfYear(1)),
                toDate: TODAY_FORMATTED,
            },
            [LAST_YEAR]: {
                fromDate: formatToNbDate(moment().subtract(1, 'year').dayOfYear(1)),
                toDate: formatToNbDate(moment().subtract(1, 'year').month(11).date(31)),
            },
        };
    }

    getDateValues(key) {
        return this.#predefinedDates()[key];
    }
    getPredefinedKey({ fromDate, toDate }) {
        const key = Object.keys(this.#predefinedDates()).find(
            (key) =>
                this.#predefinedDates()[key].fromDate === fromDate && this.#predefinedDates()[key].toDate === toDate
        );

        return key;
    }
}
